import { render } from "./CampaignsManagementDetailsDates.vue?vue&type=template&id=1275038e&scoped=true"
import script from "./CampaignsManagementDetailsDates.vue?vue&type=script&lang=js"
export * from "./CampaignsManagementDetailsDates.vue?vue&type=script&lang=js"

import "./CampaignsManagementDetailsDates.vue?vue&type=style&index=0&id=1275038e&lang=scss&scoped=true"

import exportComponent from "/var/pmweb/builder/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1275038e"]])

export default __exports__